import { useCallback, useMemo } from 'react';
import { ShortcutText } from 'src/components';
import { ToolbarIcon } from 'src/components/RichTextEditor';
import { appShortcuts } from 'src/constants/appShortcuts';
import { Conversation, Macro } from 'src/graphql';
import { Modals, useModalMethods } from 'src/store/modals';
import { useRegisterShortcuts } from 'src/utils/hooks';

export const MacrosTrigger = ({
  onMacroSelected,
  conversation,
}: {
  onMacroSelected: (macro: Macro, interpolatedMessage: string) => void;
  conversation: Conversation;
}) => {
  const { showModal } = useModalMethods(Modals.MacrosModal);

  const openModal = useCallback(() => {
    showModal({
      conversation,
      onMacroSelected,
    });
  }, [conversation, onMacroSelected, showModal]);

  useRegisterShortcuts(
    useMemo(
      () => ({
        ...appShortcuts.openMacros,
        callback: () => {
          openModal();
          return false;
        },
      }),
      [openModal],
    ),
  );

  return (
    <ToolbarIcon
      size="small"
      data={{
        onClick: openModal,
        title: (
          <ShortcutText
            label="Add Macro"
            shortcut={appShortcuts.openMacros.command}
            size="small"
          />
        ),
        icon: 'zap',
        iconLibrary: 'lucide',
      }}
    />
  );
};
